import {loadSVGIcons} from '../utilities/index.js';

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector(".product-icon-container") || document.querySelector(".support-tiles-block")) {
        loadSVGIcons();
    }
});





